<template>

    <div>
        <el-card>
            <h1>{{ $t('home.homePage', { msg: 'home.homePage' }) }}</h1>
        </el-card>
        <div v-if="items == null">
            <!-- <div v-if = "items===null"> -->
            <el-row :gutter="20">
                <el-col :span="24">

                    <el-row :gutter="16" style="margin-top:10px;">
                        <el-col :span="12">
                            <el-card style="height: 340px">
                                <el-form :rules="rules" :model="localPersonalPageForm" label-width="80px"
                                    ref="localPersonalPage">
                                    <el-form-item :label="$t('home.username', { msg: 'home.username' })"
                                        prop="username">
                                        <el-input type="text" v-model="localPersonalPageForm.username" disabled />
                                    </el-form-item>
                                    <el-form-item :label="$t('login.name', { msg: 'login.name' })" prop="name">
                                        <el-input type="text" v-model="localPersonalPageForm.name" />
                                    </el-form-item>
                                    <el-form-item :label="$t('login.password', { msg: 'login.password' })"
                                        prop="password">
                                        <el-input type="text" v-model="localPersonalPageForm.passwordPlainText"
                                            show-password />
                                    </el-form-item>
                                    <el-form-item :label="$t('login.email', { msg: 'login.email' })" prop="email">
                                        <el-input type="text" v-model="localPersonalPageForm.email" />
                                    </el-form-item>
                                    <el-button type="primary" size="large" @click="submitForm()">{{ $t('login.save', {
                                        msg:
                                            'login.save'
                                    }) }}</el-button>
                                    <el-button type="success" size="large" @click="handleClick()">{{
                                        $t('issueTrack.home', {
                                            msg: 'issueTrack.home'
                                        }) }}</el-button>
                                    <el-button type="warning" @click="handeltoapply()">{{
                                        $t('applyoutsider.accountapply', {
                                            msg: 'applyoutsider.accountapply'
                                        }) }}</el-button>
                                </el-form>
                            </el-card>
                        </el-col>

                        <el-col :span="12">
                            <!-- <el-card style="height: 340px">
       <h1><el-image src="favicon.ico"></el-image>{{ $t('home.contactUs', { msg: 'home.contactUs' }) }}</h1>
       <p class="pleft"></p><br><br><br><br><br><br><br><br><br><br>
       <p class="pleft"><b>{{ $t('home.sysEmail', { msg: 'home.sysEmail' }) }}www.issuebye@shcompass.com</b></p>
       <p class="pleft"><b>{{ $t('login.compass', { msg: 'login.compass' }) }}</b></p>
    </el-card> -->
                        </el-col>

                    </el-row>
                </el-col>
            </el-row>
            <el-dialog title="专家申请" v-model="dialogFormVisible" width="50%" @close="reset1SelectedType">
  <el-form class="custom-form" ref="expertForm" width="100%" :model="expertForm" :rules="expertRulesForUser">
    <el-row :gutter="20">



<!-- 剩下的文本框部分，占据两块（12列） -->
<el-col :span="24">
  <el-row>
    <el-col :span="24">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="expertForm.name"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="用户" prop="username">
        <el-input v-model="expertForm.username"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="expertForm.email"></el-input>
      </el-form-item>
    </el-col>
  </el-row>

</el-col>

</el-row>
    <el-form-item label="简介" prop="biography">
      <el-input type="textarea" v-model="expertForm.biography"
        :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
    </el-form-item>
        <el-form-item label="语言" prop="selectedLanguagesForUser">
      <el-select v-model="expertForm.selectedLanguagesForUser" multiple placeholder="请选择语言"  class="custom-width" >
        <el-option v-for="language in languageOptionsForUser" :key="language.value" :label="language.label"
          :value="language.label"></el-option>
      </el-select>
    </el-form-item>


    <el-form-item label="标签" prop="selectedLabelsForUser">
      <el-select v-model="expertForm.selectedLabelsForUser" multiple filterable placeholder="修改标签"
        class="custom-width">
        <el-option v-for="item in expertLabelOptions" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </el-form-item>


    <el-form-item label="经验" prop="yearsOfExperience">
      <el-radio-group v-model="expertForm.yearsOfExperience"  class="custom-width">
        <!-- <el-input v-model="expertForm.yearOfExperience" ></el-input> -->
        <el-radio-button label="1">&lt;3年</el-radio-button>
        <el-radio-button label="2">3~5年</el-radio-button>
        <el-radio-button label="3">5~10年</el-radio-button>
        <el-radio-button label="4">>10年</el-radio-button>
      </el-radio-group>
    </el-form-item>

      <!-- <el-form-item label="密码" prop="password">
      <el-input type="password" v-model="expertForm.password"></el-input>
    </el-form-item>
    <el-form-item label="确认" prop="confirmPassword">
      <el-input type="password" v-model="expertForm.confirmPassword"></el-input>
    </el-form-item> -->


  
    <!-- 根据需要添加更多表单项 -->
    <!-- ... -->

       <el-form-item>
         <el-button type="primary" @click="submitExpertFormForUser">注册</el-button>
         <el-button @click="resetExpertFormForUser">重置</el-button>
       </el-form-item>
       </el-form>
    </el-dialog>
            <!-- <el-dialog :title="$t('login.applyRole', { msg: 'login.applyRole' })" v-model="dialogFormVisible"
                width="30%" center destroy-on-close>
                <el-form ref="outsiderFrom" :model="outsiderFrom" :rules="rulespay" label-width="120px">
                    <el-form-item :label="$t('applyoutsider.applytips', { msg: 'applyoutsider.applytips' })"
                        prop="applyTips">
                        <el-input type="textarea" v-model="outsiderFrom.applyTips"
                            :placeholder="$t('applyoutsider.inputapply', { msg: 'applyoutsider.inputapply' })"></el-input>
                    </el-form-item>
                    <div v-show="outsiderFrom.roleId == 4">
                        <el-form-item :label="$t('applyoutsider.companyName', { msg: 'applyoutsider.companyName' })"
                            prop="companyName">
                            <el-input v-model="outsiderFrom.companyName"
                                :placeholder="$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' })"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item :label="$t('applyoutsider.cert', { msg: 'applyoutsider.cert' })" prop="cert">
                        <el-upload ref='upload' class="upload-demo" :action="uploadUrl" :on-preview="handlePreviewTrace"
                            :on-remove="handleRemoveTrace" :file-list="fileListCert" :on-success="handleUploadSuccess"
                            :on-change="handleChangeTrace" :before-upload="handleBeforeUpload" :multiple="true">
                            <el-button size="small" type="success">{{ $t('issueTrack.uploadClick', {
                                msg:
                                    'issueTrack.uploadClick'
                            }) }}</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item :label="$t('applyoutsider.resume', { msg: 'applyoutsider.resume' })" prop="resume">
                        <el-upload ref='upload' class="upload-demo" :action="uploadUrl" :on-preview="handlePreviewTrace"
                            :on-remove="handleRemoveTrace" :file-list="fileListResume" :on-success="resumeUploadSuccess"
                            :on-change="handleChangeTrace" :before-upload="handleBeforeUpload" :multiple="true">
                            <el-button size="small" type="success">{{ $t('issueTrack.uploadClick', {
                                msg:
                                    'issueTrack.uploadClick'
                            }) }}</el-button>
                        </el-upload>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmitpay('outsiderFrom')">{{ $t('kbinfo.createNow', {
                            msg:
                                'kbinfo.createNow'
                        }) }}</el-button>
                        <el-button @click="resetFormpay('outsiderFrom')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' })
                            }}</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog> -->
        </div>
        <div v-else>
            <el-card>
                <el-form ref="items" :model="items" :rules="expertRules" label-width="100px" class="form-container">
                    <!-- First row -->
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model="items.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用户名" prop="username">
                                <el-input v-model="items.username"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="items.email"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="电话" prop="phoneNumber">
                                <el-input v-model="items.phoneNumber"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地点" prop="location">
                                <el-input v-model="items.location"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item label="年限">
                            <el-input v-model="items.yearsOfExperience" prop="yearsOfExperience"></el-input>
                        </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                            <el-form-item label="经验" prop="yearsOfExperience">
                                <!-- <el-radio-group v-model="items.yearsOfExperience" style="width: 100%"
                                    class="radio-group-custom">
                                    <el-radio-button label="1">&lt;3年</el-radio-button>
                                    <el-radio-button label="2">3~5年</el-radio-button>
                                    <el-radio-button label="3">5~10年</el-radio-button>
                                    <el-radio-button label="4">>10年</el-radio-button>
                                </el-radio-group> -->
                                <!-- <el-input v-model="items.yearsOfExperience" prop="yearsOfExperience"></el-input> -->
                                <el-tag style="float: left;">{{ formattedExperience  }} </el-tag>

                            </el-form-item>
                        </el-col>

                    </el-row>

                    <!-- Second row -->
                    <el-row>
                        <el-col :span="12">

                            <el-form-item label="语言" prop="selectedLanguages">
                                <el-select v-model="selectedLanguages" multiple placeholder="修改语言" class="custom-width">
                                    <el-option param="selectedLanguages" v-for="language in languageOptions"
                                        :key="language" :label="language" :value="language"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="标签" prop="selectedLabels">
                                <el-select v-model="selectedLabels" multiple filterable placeholder="修改标签"
                                    class="custom-width">
                                    <el-option param=selectedLabels v-for="item in expertLabelOptions" :key="item"
                                        :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>


                    </el-row>
                    <el-row>

                    </el-row>


                    <el-row>
                        <el-col :sapn="12">
                            <el-form-item label="密码" prop="password"
                                style="width: 50%;   display: flex; justify-content: flex-start;">
                                <el-input v-model="items.password" show-password></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- <el-form-item label="语言" prop="languages">
                      <el-select v-model="items" multiple placeholder="修改语言">
                        <el-option v-for="language in items.languagesSpoken" :key="language" :label="language"
                          :value="language"></el-option>
                      </el-select>
                    </el-form-item> -->

                    <!-- Other fields -->
                    <el-form-item label="简介" class="full-width" prop="biography">
                        <el-input type="textarea" v-model="items.biography"
                            :autosize="{ minRows: 2, maxRows: 10 }"></el-input>
                    </el-form-item>
                    <!-- 

                    <el-form-item label="简历" class="full-width" prop="specialization">
                        <el-input v-model="items.specialization"></el-input>
                    </el-form-item>
                    <el-form-item label="证书" class="full-width" prop="qualifications">
                        <el-input type="textarea" v-model="items.qualifications"></el-input>
                    </el-form-item> -->
                    <el-row :gutter="20">
                        <el-col span="12">
                            <el-form-item label="简历" class="full-width" prop="fileResume">
                                <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePreview"
                                    :on-remove="handleResumeRemove" :before-remove="beforeRemove"
                                    :on-success="resumeUploadSuccessexpert" :limit="1" :on-exceed="handleExceedresume"
                                    :file-list="fileResume">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <template v-slot:tip>
                                        <div class="el-upload__tip">简历，限制1个文件</div>
                                        <!-- <div class="el-upload__tip" v-if="fileResume.length"> {{ items.resumeFileName }}</div> -->

                                    </template>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col span="12">
                            <el-form-item label="资质/证书" class="full-width" prop="fileCertificate">
                                <el-upload class="upload-demo" :action=uploadUrl :on-preview="handlePreview"
                                    :before-remove="beforeRemove" multiple :limit="6"
                                    :on-success="certificateUploadSuccessexpert" :on-exceed="handleExceedcertificate"
                                    :on-change="handlechangecertificate" :on-remove="handleCertificateRemove"
                                    :file-list="fileCertificate">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <template v-slot:tip>
                                        <div class="el-upload__tip">资质证书，限制6个文件</div>
                                        <!-- <div v-for="file in fileCertificate" :key="file" class="el-upload__tip">{{ file}}</div> -->

                                    </template>
                                    <!-- <template v-slot:file="{ file }">
                                        <div class="custom-file-list">
                                        <div v-for="file in fileCertificate" :key="file"> {{ file}}</div>

                                        <el-icon><i class="el-icon-document"></i></el-icon>
                                        <el-icon v-if="file.status === 'success'"><i class="el-icon-check"></i></el-icon>
                                        </div>
                                    </template> -->
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>



                    <el-form-item label="活跃">
                        <el-switch v-model="items.isActive" :active-value="1" :inactive-value="0"
                            prop="isActive"></el-switch>
                    </el-form-item>
                    <el-form-item label="评分" size="large">
                        <el-rate v-model="items.rating" disabled></el-rate>
                    </el-form-item>

                    <!-- Back button -->
                    <el-form-item>
                        <el-button type="primary" size="large" @click="submitExpertForm()">{{ $t('login.save', {
                            msg:
                                'login.save'
                        }) }}</el-button>
                        <el-button type="success" size="large" @click="handleClick()">{{
                            $t('issueTrack.home', {
                                msg: 'issueTrack.home'
                            }) }}</el-button>
                        <!-- <el-button type="warning" @click="handeltoapply()">{{
                        $t('applyoutsider.accountapply', {
                            msg: 'applyoutsider.accountapply'
                        }) }}</el-button> -->
                    </el-form-item>

                </el-form>
            </el-card>
        </div>
    </div>



</template>

<script>
import { baseUrl_New } from '../../axios/urlconfig';
import { getRequest, postRequest } from '../../axios/axios';
import axios from 'axios';




export default {
    computed: {
    formattedExperience() {
      const totalMonths = this.items.yearsOfExperience;
      console.log(totalMonths+'sl');

      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;
      
      if (years > 0) {
        return `距今 ${years} 年 ${months} 个月工作经验`;
      } else {
        return `距今 ${months} 个月工作经验`;
      }
    }},
    data() {

        return {
            // selectedLabelsForUser: [],
            // selectedLanguagesForUser: [],
            languageOptionsForUser: [{
        value: '选项1',
        label: 'English'
      }, {
        value: '选项2',
        label: 'French'
      }, {
        value: '选项3',
        label: 'Spanish'
      }, {
        value: '选项4',
        label: 'Chinese'
      }, {
        value: '选项5',
        label: 'Japanese'
      }],

            expertForm: {
        name: '',
        username: '',
        email: '',
        qualifications: '',
        location: '',
        biography: '',
        yearOfExperience: '',
        profileImage: '',
        password: '',
        // languagesSpoken: [],
        // expertLables: [],
        selectedLabelsForUser: [],
        selectedLanguagesForUser: [],


        // 根据需要添加更多表单字段
      },
      dialogFormVisible1:false,
      

            // fileList: [],
            fileResume: [],
            fileCertificate: [],
            // fileProfileImage: [],

            options1: [],
            value1: '',


            showPasswordField: false,
            languageOptions: ['English', 'French', 'Spanish', 'Chinese', 'Japanese'],
            expertLabelOptions: [],
            // items: null,
            // items: {
            //     name: '',
            //     username: '',
            //     email: '',
            //     qualification: '',
            //     location: '',
            //     biography: '',
            //     yearOfExperience: '',
            //     profileImage: '',
            //     password: '',
            //     languagesSpoken: [],
            // },
            items: null,
            selectedLanguages: [],
            selectedLabels: [],
            expertRules: {
                languagesSpoken: [
                    { required: true, message: '请选择至少一种语言', trigger: 'change' }
                ],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
                ],
                qualification: [{ required: true, message: '请输入技能', trigger: 'blur' }],
                biography: [{ required: true, message: '请输入简介', trigger: 'blur' }],
                yearOfExperience: [{ required: true, message: '请选择经验', trigger: 'change' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
                ],
                // confirmPassword: [
                //   { required: true, message: '请确认密码', trigger: 'blur' },
                //   {
                //     validator: (rule, value, callback) => {
                //     //   if (value !== this.expertForm.password) {
                //     //     callback(new Error('两次输入的密码不一致'));
                //     //   } else {
                //     //     callback();
                //     //   }
                //     }, trigger: 'blur'
                //   }
                // ],
                profileImage: [{ required: true, message: '请上传头像', trigger: 'change' }],
                phoneNumber: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && !/^[\d*]{11}$/.test(value)) {
                                callback(new Error('联系电话长度应为11位，可以包含数字和*'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            localPersonalPageForm: {
                id: '',
                username: '',
                name: '',
                password: '',
                email: ''
            },
            localExpertlPageForm: {},

            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入正确的Email', trigger: 'blur' }
                ],
            },
            dialogFormVisible: false,
            outsiderFrom: {
                companyName: '',
                email: '',
                name: '',
                password: '',
                roleId: 5,
                username: '',
                applyTips: '',
                resumeUrl: [],
                certificateUrl: [],
            },
            uploadUrl: baseUrl_New + "/oss/file/uploadFile",//图片上传
            rulespay: {
                name: [
                    { required: true, message: this.$t('login.nameP', { msg: 'login.nameP' }), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('user.lengthD150', { msg: 'user.lengthD150' }), trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('login.passwordP', { msg: 'login.passwordP' }), trigger: 'blur' },

                ],
                username: [
                    { required: true, message: this.$t('login.notnull', { msg: 'login.notnull' }), trigger: 'blur' },
                    { min: 1, max: 15, message: this.$t('kbType.lengthD15', { msg: 'kbType.lengthD15' }), trigger: 'blur' }
                ],
                email: [
                    { required: true, message: this.$t('login.emailP', { msg: 'login.emailP' }), trigger: 'blur' },
                    { pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/, message: this.$t('user.emailP', { msg: 'user.emailP' }), trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: this.$t('applyoutsider.tipsrole', { msg: 'applyoutsider.tipsrole' }), trigger: 'blur' }
                ],
                applyTips: [
                    { required: true, message: this.$t('applyoutsider.inputapply', { msg: 'applyoutsider.inputapply' }), trigger: 'blur' }
                ]
            },
            options: [{
                id: 1,
                value: 4,
                label: this.$t('applyoutsider.opuser', { msg: 'applyoutsider.opuser' })
            }, {
                id: 2,
                value: 5,
                label: this.$t('applyoutsider.opexpert', { msg: 'applyoutsider.opexpert' })
            }],
            companyData: [],
            fileListCert: [],
            fileListResume: [],
            expertRulesForUser: {
        yearsOfExperience: [{ required: true, message: '请选择年限', trigger: 'change' }],
        selectedLanguagesForUser: [
          { required: true, message: '请选择至少一种语言', trigger: 'blur' }
        ],
        selectedLabelsForUser: [{ required: true, message: '请选择至少一种标签', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        qualifications: [{ required: true, message: '请输入技能', trigger: 'blur' }],
        // biography: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        yearOfExperience: [{ required: true, message: '请选择经验', trigger: 'change' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.expertForm.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        // profileImage: [{ required: true, message: '请上传头像', trigger: 'change' }]
      },

        }
    },
    created() {
        this.getUserInfo();
        this.getcompanylist();
        this.getExpertInfo();
        this.getExpertLabel();
    },
    mounted() {
        // this.selectedLanguages = this.items ? this.items.languagesSpoken : [];
    },

    methods: {
        submitExpertFormForUser() {
            this.dialogFormVisible1=true;
      this.$refs.expertForm.validate((valid) => {
        if (valid) {


          this.expertForm.languagesSpoken = this.expertForm.selectedLanguagesForUser.map(language => ({ language }));
          this.expertForm.expertLabel = this.expertForm.selectedLabelsForUser.map(label => ({ label }));


          // 使用 FormData 对象进行 POST 请求
          axios.post(baseUrl_New + '/expert/add', this.expertForm)

            .then(response => {
              this.$message.success('申请成功');
              this.isExpertSelected = false; // 关闭对话框
              this.resetExpertForm();
            })
            .catch(error => {
              this.$message.error('申请失败');
              console.error(error);
            });
        } else {
          this.$message.error('表单验证失败，请检查输入!');
          return false;
        }
      });
    },
        handlechangeresume(file, fileList) {
            this.fileResume = fileList;
            console.log(this.fileResume);
        },
        handlechangecertificate(file, fileList) {

            // this.fileCertificate = fileList;
            // console.log("change"+this.fileCertificate[0].url);
            // console.log("change"+this.fileCertificate[1].url);
        },

        handleResumeRemove(file, fileList) {
            this.fileResume = fileList;
            console.log(this.fileResume);

            // console.log(file, fileList
        },
        handleCertificateRemove(file, fileList) {
            this.fileCertificate = fileList;
            console.log(this.fileCertificate);

            // console.log(file, fileList
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceedresume(files, fileList) {
            this.$message.warning(`限制选择 1 个文件`);
        },
        handleExceedcertificate(files, fileList) {
            this.$message.warning(`限制选择 6个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },

        togglePasswordField() {
            this.showPasswordField = !this.showPasswordField;
        },

        getExpertLabel() {
            getRequest(baseUrl_New + "/expert/label").then(res => {
                this.expertLabelOptions = res.data.data;
            });
        },
        submitForm() {
            this.$refs['localPersonalPage'].validate((valid) => {
                // console.log('Form validation result: ' + valid);    
                if (valid) {
                    postRequest(baseUrl_New + "/updateuserinfo", this.localPersonalPageForm).
                        then(res => {
                            if (res === 1) {
                                this.$message.success('保存成功！');
                            } else {
                                this.$message.error('保存失败！');
                            }
                        }).catch(err => {
                            console.log(err);
                        })
                }
            });
        },


        handleClick() {
            this.$router.push('/issue')
        },

        getUserInfo() {
            let username = sessionStorage.getItem('username');
            getRequest(baseUrl_New + "/queryuser/" + username).
                then(res => {
                    console.log(res);
                    this.localPersonalPageForm.id = res.id;
                    this.localPersonalPageForm.username = res.username;
                    this.localPersonalPageForm.name = res.name;
                    this.localPersonalPageForm.passwordPlainText = res.passwordPlainText;
                    this.localPersonalPageForm.email = res.email;
                }).catch(err => {
                    console.log(err);
                })
        },
        submitExpertForm() {
            this.$refs.items.validate((valid) => {
                if (valid) {
                    // this.items.languagesSpoken = this.selectedLanguages;
                    this.items.languagesSpoken = this.selectedLanguages.map(language => ({ language }));
                    this.items.expertLabel = this.selectedLabels.map(label => ({ label }));

                    // this.items.resume = this.fileResume;
                    // this.items.resume = this.fileResume.length > 0 ? this.fileResume : '';

                    // // this.items.profileImage = this.fileProfileImage;
                    // this.items.qualification = this.fileCertificate.map(certificate => ({certificate}));
                    // this.items.resume = this.fileResume.length > 0 ? this.fileResume.url[0] : '';
                    this.items.resume = this.fileResume.length ? this.fileResume[0].url : '';
                    // this.items.resume = this.fileResume ;

                    this.items.qualification = this.fileCertificate.map(certification => ({
                        qualification: certification.url
                    }));

                    postRequest(baseUrl_New + '/expert/update', this.items)
                        .then(response => {
                            this.$message.success('修改成功');
                            //   this.isExpertSelected = false; // 关闭对话框
                        })
                        .catch(error => {
                            this.$message.error('修改失败');
                            console.error(error);
                        });
                }
            });
        },
        getExpertInfo() {
            // try {
            let userid = sessionStorage.getItem('userid');

            // const response = getRequest(baseUrl_New + '/expert/getbyuserid/' + userid);
            getRequest(baseUrl_New + '/expert/getbyuserid/' + userid)
                .then(res => {
                    console.log(res);
                    this.items = res.data.dat;
                    this.items.isActive = Number(this.items.isActive);


                    this.selectedLanguages = this.items.languagesSpoken.map(item => item.language);
                    this.selectedLabels = this.items.expertLabel.map(item => item.label);
                    // this.fileCertificate = this.items.qualification.map(item => item.qualification);
                    // this.fileResume = this.items.resume;
                    console.log(this.fileResume + "asf");
                    console.log(this.fileCertificate + "asf");
                    // console.log(this.fileResume + "asf");

                    // this.fileCertificate = this.items.qualificationFileName.map(item => item.qualification)
                    // this.fileCertificate = this.items.qualificationFileName;
                    this.fileCertificate = this.items.qualification.map((item, index) => ({
                        name: this.items.qualificationFileName[index],
                        url: item.qualification
                    }));
                    if (this.items.resume) {
                        this.fileResume = [{
                            name: this.items.resumeFileName,
                            url: this.items.resume,
                            // status: 'success' // 设定状态为成功以显示图标
                        }];
                    } else {
                        this.fileResume = []; // 确保 fileResume 为空数组
                    }
                })
                .catch(err => { console.log(err); })

            // const resultMap = response.data.dat;
            // this.items = response.data.dat; // 根据返回的数据结构进行调整
            // this.filteredItems = this.items; // 初始化时显示所有用户
            // this.total = resultMap.total; // 根据返回的数据结构进行调整
            // } catch (error) {
            //     console.error('Error fetching data:', error);
            // }
        },
        transdata() {
            this.outsiderFrom.email = this.localPersonalPageForm.email;
            this.outsiderFrom.name = this.localPersonalPageForm.name;
            this.outsiderFrom.password = this.localPersonalPageForm.password;
            this.outsiderFrom.username = this.localPersonalPageForm.username;
        },
        //账户申请
        onSubmitpay(formName) { //新增用户
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var that = this
                    postRequest(baseUrl_New + '/out/addOut', {
                        companyName: this.outsiderFrom.companyName,
                        email: this.outsiderFrom.email,
                        name: this.outsiderFrom.name,
                        password: this.outsiderFrom.password,
                        roleId: this.outsiderFrom.roleId,
                        username: this.outsiderFrom.username,
                        applyTips: this.outsiderFrom.applyTips,
                        certificateUrl: this.outsiderFrom.certificateUrl,
                        resumeUrl: this.outsiderFrom.resumeUrl,
                    }).then(resp => {
                        this.$message.success(this.$t('applyoutsider.applysucc', { msg: 'applyoutsider.applysucc' }));
                        this.handletoclose();
                        this.resetFormpay('outsiderFrom');

                    }).catch(err => {
                        console.log(err);
                    });
                }
            });
        },
        resetFormpay(outsiderFrom) {
            this.$refs[outsiderFrom].resetFields();
            this.$refs.upload.value.clearFiles();
            this.outsiderFrom.certificateUrl = [];
            this.outsiderFrom.resumeUrl = [];
        },
        handeltoapply() {
            this.dialogFormVisible = true;
            this.transdata();
        },
        handletoclose() {
            this.dialogFormVisible = false;
        },
        getcompanylist() {
            getRequest(baseUrl_New + '/company/getlist').then(response => {

                this.companyData = response.data;
            })
        },
        handleRemoveTrace(file, fileList) {
            console.log(file, fileList);
        },
        handlePreviewTrace(file) {
            console.log(file);
        },
        handleUploadSuccess(res, file, fileList) { //成功之后把值 证书传给Url[]
            this.outsiderFrom.certificateUrl.push(res.data.fileUrl);
        },
        handleChangeTrace(file, fileList) {

        },
        resumeUploadSuccess(res, file, fileList) { //成功之后把值 简历传给Url[]
            this.outsiderFrom.resumeUrl.push(res.data.fileUrl);
        },
        resumeUploadSuccessexpert(res, file, fileList) {
            this.fileResume = [{
                name: file.name, // 使用 fileList 作为文件名
                url: res.data.fileUrl,
                // status: 'success'
            }];


            //         console.log(this.fileResume)
            //         console.log(res.data.fileUrl);
            // this.fileResume = res.data.fileUrl;
            // console.log("sfz"+this.fileResume);
        },

        certificateUploadSuccessexpert(res, file, fileList) {
            // this.fileResume = res.data;
            // this.fileCertificate = [...res.data.fileUrl]; // 确保之前上传的文件不会被覆盖
            // 假设 res.data.fileUrl 是一个包含文件URL的数组
            const newFiles = {
                name: file.name, // 假设你以后会为这个文件名赋值
                url: res.data.fileUrl
            };

            console.log(res);
            console.log(res.data.fileUrl);
            console.log(newFiles.url + "upload");


            // 追加新文件到 fileCertificate 数组中
            this.fileCertificate = [...this.fileCertificate, newFiles];

            this.fileCertificate.forEach(file => {
                console.log(`Name: ${file.name}, URL: ${file.url}`);
            });



        },
        fileProfileImageUploadSuccess(res, file, fileList) {
            this.fileProfileImage = res.data.fileUrl;
        },
        // 限制图片大小
        handleBeforeUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error(this.$t('issueTrack.uploadInfo', { msg: 'issueTrack.uploadInfo' }));
            }
            return isLt10M
        },
        resetExpertForm() {
      this.$refs.expertForm.resetFields(); // 重置表单字段
      this.selectedLanguagesForuser = [];
      this.expertForm.profileImage = ''; // 重置上传的图片
      this.expertForm.yearsOfExperience = '';
      this.selectedLabelsForuser = [];
      // 根据需要重置其他表单字段
    },


    },

}

</script>

<style scoped>
.pleft {
    text-align: left;
}

.input-align-left {
    text-align: left;

}

.form-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;


}

.custom-width {
    width: 100%;
    /* height: 1000px; */


}

.radio-group-custom {
    display: flex;
    justify-content: flex-start;
    width: 100%;
}

/* .el-radio-button {
  margin-right: 10px; 
  width: 100px;
} */

.custom-form-item {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.custom-form-item::v-deep .el-form-item__label {
    font-size: 14px;
    color: #606266;
    font-weight: bold;
    margin-bottom: 8px;
    transition: color 0.3s ease;
}

.custom-form-item::v-deep .el-form-item__label::after {
    content: ":";
}

.custom-input {
    border: none;
    border-radius: 8px;
    background-color: #f5f7fa;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 15px;
    transition: all 0.3s ease;
    font-size: 14px;
    resize: none;
    /* Prevents resizing of textarea */
}

.custom-input:focus {
    outline: none;
    border: none;
    box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
    background-color: #ffffff;
    /* Change background on focus */
}

.custom-input::placeholder {
    color: #a0a4a8;
    /* Light gray for placeholder text */
    font-style: italic;
    /* Italicize placeholder text */
}
.custom-form {
  box-shadow: none;
  /* 去除阴影 */
  border: none;
  /* 去除边框 */
  width: 100%;
  /* 设置表单宽度 */
}
</style>